import apiClient from "./axiosConfig";

// Get brands list with search and pagination
export const getBrandsList = async (params = {}) => {
  try {
    const { search = '', page = 1, page_size = 10, category_id } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (page) queryParams.append('page', page);
    if (page_size) queryParams.append('page_size', page_size);
    if (category_id) queryParams.append('category_id', category_id);
    
    const response = await apiClient.get(`/products/brand/list/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create new brand
export const createBrand = async (brandData) => {
  try {
    const formData = new FormData();
    formData.append('name', brandData.name);
    formData.append('categories', JSON.stringify(brandData.category_id));
    formData.append('description', brandData.description || '');
    
    // Add image file if provided
    if (brandData.image) {
      formData.append('image', brandData.image);
    }
    
    const response = await apiClient.post('/products/brand/create/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update brand
export const updateBrand = async (brandId, brandData) => {
  try {
    const formData = new FormData();
    
    // Only append fields that are provided (not undefined/null)
    if (brandData.name !== undefined) {
      formData.append('name', brandData.name);
    }
    if (brandData.category_id !== undefined) {
      formData.append('categories', JSON.stringify(brandData.category_id));
    }
    if (brandData.description !== undefined) {
      formData.append('description', brandData.description || '');
    }
    
    // Only add image if a new image file is provided
    if (brandData.image) {
      formData.append('image', brandData.image);
    }
    
    const response = await apiClient.patch(`/products/brand/update/${brandId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete brand
export const deleteBrand = async (brandId) => {
  try {
    const response = await apiClient.delete(`/products/brand/delete/${brandId}/`);
    // Handle 204 No Content status code
    if (response.status === 204) {
      return { success: true };
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get brand statistics
export const getBrandStats = async () => {
  try {
    const response = await apiClient.get('/products/brand/count/');
    return response.data;
  } catch (error) {
    throw error;
  }
};